import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExternalLink } from '@/components/Icons/ExternalLink';
import { Button } from '@/components/ui/button';
const URLS_SHOW_MORE = 3;
const getLimit = (urlsLength, integrationLimit, showMore) => {
    const maxLimit = Math.min(urlsLength, integrationLimit);
    if (showMore) {
        // When 'showMore' is true, show up to the maximum allowed
        return maxLimit;
    }
    else {
        // Otherwise, show up to 'URLS_SHOW_MORE' or the integration limit, whichever is less
        return Math.min(maxLimit, URLS_SHOW_MORE);
    }
};
export const References = ({ urls, maxReferences, onClick }) => {
    const { t } = useTranslation();
    const [showMore, setShowMore] = useState(false);
    const handleSeeMoreClick = useCallback(() => {
        onClick({
            type: 'see_more_references',
        });
        setShowMore(true);
    }, [onClick]);
    if (!urls || urls.length === 0) {
        return null;
    }
    const maxLimit = Math.min(urls.length, maxReferences);
    const limitToShow = getLimit(urls.length, maxReferences, showMore);
    return (_jsxs("div", { className: "dark:border-input mt-3 flex flex-col border-t border-gray-200 pt-3", children: [_jsx("p", { className: "text-foreground mb-3 text-sm leading-5", children: t('related_articles') }), _jsxs("ul", { className: "m-0 list-none p-0", children: [urls.slice(0, limitToShow).map(({ name, external_url }) => (_jsx("li", { className: "mb-3 max-w-fit hover:underline", children: _jsxs("a", { className: "flex items-center gap-1 no-underline", href: external_url, target: "_blank", rel: "noreferrer", onClick: () => onClick({
                                type: 'reference_url',
                                label: name,
                                value: external_url,
                            }), children: [_jsx("span", { className: "text-accent inline-block max-w-full min-w-0 overflow-hidden text-sm leading-5 text-ellipsis whitespace-nowrap", children: name }), _jsx(ExternalLink, { color: "var(--color-accent)", className: "shrink-0" })] }) }, external_url))), maxLimit > URLS_SHOW_MORE && !showMore && (_jsx(Button, { variant: "link-secondary", onClick: handleSeeMoreClick, size: "sm", className: "w-fit min-w-fit p-0", children: t('buttons.show_more') }))] })] }));
};
